export default function LinkButton({
  value,
  variant,
  iconBefore,
  iconAfter,
  className,
  sm,
  disabled,
  href,
  children,
  ...props
}) {
  const computedClassName = [
    "btn",
    (disabled && "disabled") || "",
    (!!variant && `btn-${variant}`) || "",
    (!!sm && "btn-sm") || "",
    ...className.split(" "),
  ]
    .join(" ")
    .trim();
  return (
    <a href={href} className={computedClassName} {...props}>
      {!!iconBefore && !!value && <>{iconBefore}&nbsp;</>}
      {!!children && !value && children}
      {!!value && <>{value}&nbsp;</>}
      {!!iconAfter && !!value && iconAfter}
    </a>
  );
}

LinkButton.defaultProps = {
  className: "",
};
